// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useContext, useState, useMemo} from 'react';
import {Popup} from '../../comp/popup';
import {Details} from './details.js';
import {Content_context} from './contexts.js';

function Content_context_provider({children}){
    const [footer_content, set_f_content] = useState(null);
    const [header_content, set_h_content] = useState(null);
    const value = useMemo(()=>({
        footer_content,
        header_content,
        set_f_content,
        set_h_content,
    }), [footer_content, header_content]);
    return <Content_context.Provider value={value}>
      {children}
    </Content_context.Provider>;
}

function Inner({offer, on_close}){
    const {footer_content, header_content} = useContext(Content_context);
    return <Popup title={header_content||offer?.name} show={!!offer}
      on_close={on_close} footer_content={footer_content} hide_actions>
      <Details offer={offer} on_close={on_close}/>
    </Popup>;
}

export function Details_popup({offer, on_close}){
    return <Content_context_provider>
      <Inner offer={offer} on_close={on_close}/>
    </Content_context_provider>;
}
